import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import lang from '@/lang'
import clsx from 'clsx'
import datevConfig from '../config'
import { Title } from '@/modules/base/components/texts/index'
import DatevExportContentTooltip from './datev-export-content-tooltip'
import SimpleAgGrid from '@/modules/base/components/simple-ag-grid/simple-ag-grid'
import { ContentCell, ActionCell } from '@/modules/document-export/forms/exportList/cell-renderer'

const DatevExportList = props => {
  const { className, data, readOnly } = props
  const classes = useStyles()

  const getRowHeight = ({ data }) => {
    return 20 + data.content.length * 20
  }

  return (
    <div className={clsx(classes.container, className)}>
      <Title className={classes.title}>Letzte Übertragungen</Title>
      <div className={`datev-export ${classes.list}`} >
        <SimpleAgGrid
          columns={datevConfig.exportListColumns}
          data={data}
          getRowHeight={getRowHeight}
          defaultColDef={{
            tooltipComponent: 'customTooltip',
          }}
          localeText={{
            noRowsToShow: lang.accounting.list.noRowsToShow,
            loadingOoo: lang.accounting.list.loadingOoo,
          }}
          components={{
            actionCell: (props) => (<ActionCell {...props} readOnly={readOnly} />),
            contentCell: (props) => (<ContentCell {...props} className={classes.content} />),
            customTooltip: DatevExportContentTooltip,
          }}
          tooltipShowDelay={500}
          showBorder={false}
          pagination={true}
        />
      </div>
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    marginBottom: 30,
  },
  list: {
    width: '100%',
    '& .datevExportContentCell > *': {
      marginTop: 'auto',
      marginBottom: 'auto',
    },
  },
  content: {
    '& span': {
      width: 200,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
}))

DatevExportList.defaultProps = {
  readOnly: false,
}

DatevExportList.propTypes = {
  data: PropTypes.array,
  className: PropTypes.string,
  readOnly: PropTypes.bool,
}

export default DatevExportList
